import { ComponentFactoryResolver, ComponentRef, Injectable, ViewContainerRef, inject } from '@angular/core';
import { IndividualConfig, ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class NotificationFacade {
  toast = inject(ToastrService);
  resolver!: ComponentFactoryResolver;
  container!: ViewContainerRef;
  popupRef: ComponentRef<any>[] = [];

  show(message: string, title?: string, config?: IndividualConfig) {
    return this.toast.show(message, title, config);
  }

  success(message: string, title?: string, config?: IndividualConfig) {
    return this.toast.success(message, title, config);
  }

  error(message: string, title?: string, config?: IndividualConfig) {
    return this.toast.error(message, title, config);
  }

  info(message: string, title?: string, config?: IndividualConfig) {
    return this.toast.info(message, title, config);
  }

  warning(message: string, title?: string, config?: IndividualConfig) {
    return this.toast.warning(message, title, config);
  }

  clear() {
    return this.toast.clear();
  }

  showPopup(component: any) {
    // console.log("showPopup called with component:", component);
    // if (this.container) {
      const factory = this.resolver.resolveComponentFactory(component)
      const instance = this.container.createComponent(factory);
      this.popupRef.push(instance);
      console.log("Popup created: ", this.popupRef.length, " instances.");
    // }
  }

  closePopup() {
    if (this.popupRef.length) {
      this.popupRef[this.popupRef.length - 1].destroy();
      this.popupRef.pop();
    }
  }
  closeAllPopups() {
    this.popupRef.forEach(ref => ref.destroy());
    this.popupRef = [];
  }
}
